import { render, staticRenderFns } from "./IntegralMember.vue?vue&type=template&id=98413924&scoped=true&"
import script from "./IntegralMember.vue?vue&type=script&lang=ts&"
export * from "./IntegralMember.vue?vue&type=script&lang=ts&"
import style0 from "./IntegralMember.vue?vue&type=style&index=0&id=98413924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98413924",
  null
  
)

export default component.exports